module.exports = __webpack_public_path__ + "img/734959e.jpg";